import { Preferences } from '@capacitor/preferences';

export const useCapacitorPreferences = () => {
  const setPreference = async (key: string, value?: string | undefined) => {
    if (value === undefined) {
      await Preferences.remove({ key });
    }

    await Preferences.set({
      key,
      value
    });
  };

  const getPreference = async (key: string) => {
    const { value } = await Preferences.get({ key });
    return value;
  };

  return {
    setPreference,
    getPreference
  };
};
